import { AnimalType } from '../models/animal';
import { FarmType } from '../models/farm';
import { LocationStable } from '../models/locations';

export function isPigFarm(farmType: FarmType): boolean {
  if (
    farmType === FarmType.SowGiltPigletFattening ||
    farmType === FarmType.SowPiglet ||
    farmType === FarmType.Fattening ||
    farmType === FarmType.SowPigletGilts
  ) {
    return true;
  }
  return false;
}

export interface IDashboardConfig {
  isPigFarm: boolean;
  displaySow: boolean;
  displayGilt: boolean;
  displayPiglet: boolean;
  displayFattening: boolean;
  displayCow: boolean;
  displayCalf: boolean;
  displayGoat: boolean;
}

export function getDashboardConfigByFarmType(farmType: FarmType): IDashboardConfig {
  const config = {
    isPigFarm: isPigFarm(farmType),
    displaySow: false,
    displayGilt: false,
    displayPiglet: false,
    displayFattening: false,
    displayCow: false,
    displayCalf: false,
    displayGoat: false
  } as IDashboardConfig;

  switch (farmType) {
    case FarmType.SowGiltPigletFattening:
      config.displaySow = true;
      config.displayGilt = true;
      config.displayPiglet = true;
      config.displayFattening = true;
      break;

    case FarmType.SowPigletGilts:
      config.displaySow = true;
      config.displayGilt = true;
      config.displayPiglet = true;
      break;

    case FarmType.SowPiglet:
      config.displaySow = true;
      config.displayPiglet = true;
      break;

    case FarmType.Fattening:
      config.displayFattening = true;
      break;

    case FarmType.Goat:
      config.displayGoat = true;
      break;

    case FarmType.Cow:
      config.displayCow = true;
      break;

    case FarmType.Calf:
      config.displayCalf = true;
      break;

    default:
      break;
  }

  return config;
}

export function getDefaultAnimalTypeByFarmType(farmType: FarmType): AnimalType {
  const farmTypeConfig = getDashboardConfigByFarmType(farmType);

  if (farmTypeConfig.isPigFarm) {
    return AnimalType.Sow;
  }
  if (farmTypeConfig.displayCow) {
    return AnimalType.Cow;
  }
  if (farmTypeConfig.displayGoat) {
    return AnimalType.Goat;
  }
  if (farmTypeConfig.displayCalf) {
    return AnimalType.Calf;
  }
  return AnimalType.Unknown;
}

export function getAcceptedLocationStablesByFarmType(farmType: FarmType): LocationStable[] {
  const acceptedStables: LocationStable[] = [];

  const farmTypeConfig = getDashboardConfigByFarmType(farmType);

  if (farmTypeConfig.isPigFarm) {
    acceptedStables.push(LocationStable.Gestation);
    acceptedStables.push(LocationStable.Farrowing);
    acceptedStables.push(LocationStable.Quarantaine);
    acceptedStables.push(LocationStable.Fatting);
    acceptedStables.push(LocationStable.Nursery);
    acceptedStables.push(LocationStable.Mating);
    acceptedStables.push(LocationStable.Breeding);
  }

  if (farmTypeConfig.displayCow) {
    acceptedStables.push(LocationStable.Calm);
  }

  if (farmTypeConfig.displayGoat) {
    acceptedStables.push(LocationStable.Calm);
  }

  if (farmTypeConfig.displayCalf) {
    acceptedStables.push(LocationStable.Calm);
  }

  return acceptedStables;
}
